import React from "react";
import { STATUS_TONE } from "./format";

// Project Health (spec §6): status, optional score, factors, explanation.
export default function HealthCard({ health }) {
  if (!health) return null;
  const tone = STATUS_TONE[health.status] || "muted";

  return (
    <div className={`health-card tone-${tone}`}>
      <div className="health-top">
        <div>
          <span className="health-eyebrow">Project Health</span>
          <div className="health-status">
            <span className={`status-dot tone-${tone}`} />
            {health.status}
          </div>
        </div>
        {health.score != null && (
          <div className="health-score">
            <span className="health-score-n">{health.score}</span>
            <span className="health-score-d">/100</span>
          </div>
        )}
      </div>

      {health.explanation && <p className="health-explain">{health.explanation}</p>}

      <div className="health-factors">
        <FactorList title="Working well" items={health.positiveFactors} kind="good" />
        <FactorList title="Risks" items={health.negativeFactors} kind="bad" />
        <FactorList title="Investigate" items={health.investigate} kind="warn" />
      </div>
    </div>
  );
}

function FactorList({ title, items, kind }) {
  if (!items || items.length === 0) return null;
  return (
    <div className="factor-col">
      <span className={`factor-title tone-${kind}`}>{title}</span>
      <ul>
        {items.map((f, i) => (
          <li key={i}>{f}</li>
        ))}
      </ul>
    </div>
  );
}
